export default __webpack_public_path__ + "static/grid-6afaf081838f16b02a9f4e0c96d86812.png";